import { Grid, GridItem } from '@nike/nike-design-system-components';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Placement = function Placement(props) {
  var p1Placement = props.root.p1Placement;
  var p21Placement = p1Placement === 'futures' ? 'AtOnce' : 'Futures';
  return /*#__PURE__*/_jsxs(Grid, {
    placeholder: undefined,
    onPointerEnterCapture: undefined,
    onPointerLeaveCapture: undefined,
    children: [/*#__PURE__*/_jsx(GridItem, {
      className: "ncss-brand u-uppercase fs20-sm fs24-md fs28-lg",
      children: "Placement"
    }), /*#__PURE__*/_jsxs(GridItem, {
      className: "ncss-brand fs18-sm fs20-md mb5-sm",
      children: [/*#__PURE__*/_jsxs(GridItem, {
        style: {
          textTransform: 'capitalize'
        },
        children: ["The Placement in P1 is : ", p1Placement]
      }), "The Placement in P21 is : ", p21Placement]
    })]
  });
};
export default Placement;